import { render, staticRenderFns } from "./AGUSDropdownBlock.vue?vue&type=template&id=17807c94&scoped=true"
import script from "./AGUSDropdownBlock.vue?vue&type=script&lang=js"
export * from "./AGUSDropdownBlock.vue?vue&type=script&lang=js"
import style0 from "./AGUSDropdownBlock.vue?vue&type=style&index=0&id=17807c94&prod&lang=scss&scoped=true"
import style1 from "./AGUSDropdownBlock.vue?vue&type=style&index=1&id=17807c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17807c94",
  null
  
)

export default component.exports